import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Container, Success } from '../components';
import { formatPrice, formatUfPrice } from '../helpers/utils';
import { restartFlow } from '../store/Commons';
import { fetchPdf } from '../store/Success';

interface ISuccessContainerProps {
  name: string;
  email: string;
  priceUF: string;
  priceCLP: string;
  proposal: number;
  nameBank: string;
  mandateId: string;
  reset: () => void;
  getPdf: (proposal: number) => void;
  fetching: boolean;
  pdf: string;
  enableDownload: boolean;
  planName: string;
  documentId: string;
}

export function SuccessContainer(props: ISuccessContainerProps) {
  const {
    name,
    email,
    priceUF,
    priceCLP,
    proposal,
    reset,
    nameBank,
    mandateId,
    getPdf,
    fetching,
    pdf,
    enableDownload,
    planName,
    documentId
  } = props;

  return (
    <Container>
      <Success
        name={name}
        email={email}
        priceUF={priceUF}
        priceCLP={priceCLP}
        proposal={proposal}
        reset={reset}
        nameBank={nameBank}
        mandateId={mandateId}
        fetching={fetching}
        pdf={pdf}
        enableDownload={enableDownload}
        getPdf={getPdf}
        planName={planName}
        documentId={documentId}
      />
    </Container>
  );
}

export const mapStateToProps = (state: any) => {
  const {
    Quote: {
      data: { email },
      planSelected: { premium_monthly = 0, premium_monthly_CLP = 0, planName = '' },
    },
    Emit: {
      proposal: { number: proposal = 0, mandateId = ''},
      data: { nameBank = '', name, documentId = '' },
    },
    Success: { fetching, pdf, enableDownload },
  } = state;

  const priceCLP = formatPrice(premium_monthly_CLP);
  const priceUF = formatUfPrice(premium_monthly);

  return {
    email,
    enableDownload,
    fetching,
    mandateId,
    name,
    nameBank,
    pdf,
    priceCLP,
    priceUF,
    proposal,
    planName,
    documentId
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  getPdf: (proposal: number) => dispatch(fetchPdf(proposal)),
  reset: () => dispatch(restartFlow()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuccessContainer);
